module.exports = "//static.hsappstatic.net/ContentComponents/static-2.70275/img/content-remix-post-publish/content-remix-en.png"